import { sendGTMEvent as pushToDataLayer } from "@next/third-parties/google"

import { createPageViewGate, type GTMEvent, type PageViewGate } from "./pageViewGate"

const noopGate: PageViewGate = {
    dispatch: () => {},
    setPageMetadata: () => {},
    startPage: () => {},
    reset: () => {},
    getState: () => ({
        currentPageKey: null,
        pageViewSent: false,
        queuedCount: 0,
        hasStagedMetadata: false
    })
}

let clientGate: PageViewGate | null = null

const getPageViewGate = (): PageViewGate => {
    if (typeof window === "undefined") return noopGate

    if (clientGate === null) {
        // One-arg wrapper: pushToDataLayer's second parameter is the dataLayer name.
        clientGate = createPageViewGate(event => pushToDataLayer(event))
    }

    return clientGate
}

/**
 * Single gate every tracking event passes through. Holds events until the `page_view`
 * for the current page has been sent, then releases them in order. No-op on the server.
 */
export const pageViewGate: PageViewGate = {
    dispatch: event => getPageViewGate().dispatch(event),
    setPageMetadata: metadata => getPageViewGate().setPageMetadata(metadata),
    startPage: (key, payload, metadata) =>
        getPageViewGate().startPage(key, payload, metadata),
    reset: () => getPageViewGate().reset(),
    getState: () => getPageViewGate().getState()
}

export function sendGTMEvent(data: GTMEvent): void {
    getPageViewGate().dispatch(data)
}
